"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
var _Icon = require("../../media/icon/Icon");
var _InnerButton = require("../../controls/buttons/InnerButton");
var _icon = require("../../media/icon/icon.tokens");
var _globalTokenUtil = require("../../../shared/global-token-util");
var _FlexItem = require("../../layout/flex/FlexItem");
var _jsxRuntime = require("react/jsx-runtime");
var IconTooltip = function IconTooltip(_ref) {
  var children = _ref.children,
    width = _ref.width,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? 'help' : _ref$icon,
    iconSize = _ref.iconSize,
    iconColor = _ref.iconColor,
    onOpenChange = _ref.onOpenChange;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexItem.FlexItem, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      content: children,
      width: width,
      onOpenChange: onOpenChange,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.NonVisualButton, {
        "aria-label": 'tooltip',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: icon,
          size: iconSize,
          color: iconColor
        })
      })
    })
  });
};
IconTooltip.WIDTH = _Tooltip.default.WIDTH;
IconTooltip.Item = _Tooltip.default.Item;
IconTooltip.defaultProps = {
  width: _Tooltip.default.WIDTH.m,
  icon: 'help'
};
IconTooltip.IconSize = (0, _globalTokenUtil.getTokenKeyEnum)(_icon.tokens.size);
IconTooltip.IconColor = (0, _globalTokenUtil.getTokenKeyEnum)(_icon.tokens.color);
var _default = exports.default = IconTooltip;